import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 20,
    // paddingVertical: 5,
    marginTop: -15,
  },
  sectionTitle: {
    fontWeight: '700',
    marginBottom: 12,
    color: '#1C1C1E',
  },
  btnChangePhoto: {
    paddingVertical: 4,
  },
  btnChangePhotoText: {
    fontSize: 16,
    lineHeight: 22,
    marginLeft: 30,
    fontFamily: 'openSans',
    color: '#1E1E1E',
    fontWeight: '500',
  },
  avatarCircle: {
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: '#E0E0E0',
    overflow: 'hidden',
    marginRight: 16,
  },
  avatarHint: {
    color: '#6B7280',
    lineHeight: 20,
    fontSize: 13,
    fontWeight: '400',
  },
  avatarRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },

  confirmBtn: {
    minHeight: 44,
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: '#111827',
    borderColor: '#111827',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  cancelBtn: {
    minHeight: 44,
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#767676',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  confirmBtnText: {
    fontSize: 12,
    color: '#FFFFFF',
    fontWeight: '600',
  },
  cancelBtnText: {
    color: '#1E1E1E',
    fontSize: 12,
    fontWeight: '500',
  },
  avatarLoadingOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.6)',
  },

  avatarMeta: {
    flex: 1,
    minWidth: 0,
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginLeft: 16,
  },

  actionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '70%',
  },

  errorText: {
    fontSize: 13,
    color: '#DC2626',
    fontWeight: '500',
    textAlign: 'left',
  },

  retryBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: '#DC2626',
    backgroundColor: '#FEF2F2',
    borderRadius: 20,
  },

  retryBtnText: {
    fontSize: 10,
    color: '#DC2626',
    fontWeight: '600',
  },

  retryContainer: {
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },

  retryTextContainer: {
    alignItems: 'flex-start',
  },

  retryActionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 8,
  },

  retryCancelButton: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 30,
    paddingHorizontal: 8,
    marginLeft: 5,
  },

  retryCancelText: {
    fontSize: 12,
    lineHeight: 18,
    fontWeight: '600',
    textDecorationLine: 'underline',
    color: '#6B7280',
  },
  fullWidth: {
    width: '100%',
  },
});
